// Config.
import Config 	from './config/config.js';

// Misc dependencies.
import createActionTypes from '../../factories/actionTypes.js';

/**
 * <pre>
 * PrivacyManagement module Action Types.
 *
 * Summary of responsibilities:
 *
 *  - defines Redux action types specific to component
 * </pre>
 *
 * @memberof module:PrivacyManagement
 * @namespace
 *
 * @type {Object}

 * @property {String} SHOW_PRIVACY_POPUP Dispatched when we need to show the privacy consent popup.
 * @property {String} HIDE_PRIVACY_POPUP Dispatched when we need to hide the privacy consent popup.
 *
 * @property {String} SHOW_COOKIES_DISABLED_MODAL Dispatched when we need to show the blocking cookies-disabled modal.
 * @property {String} HIDE_COOKIES_DISABLED_MODAL Dispatched when we need to hide the blocking cookies-disabled modal.
 */
const ActionTypes = {

  SHOW_PRIVACY_POPUP: 'SHOW_PRIVACY_POPUP',
  HIDE_PRIVACY_POPUP: 'HIDE_PRIVACY_POPUP',

  SHOW_COOKIES_DISABLED_MODAL: 'SHOW_COOKIES_DISABLED_MODAL',
  HIDE_COOKIES_DISABLED_MODAL: 'HIDE_COOKIES_DISABLED_MODAL',

};

export default createActionTypes(ActionTypes, Config.stateKey);